<template>
  <div class="root">
    <div class="flex-layout" data-flex>
      <component v-for="item in blok.content" :key="item._uid" :blok="item" :is="item.component" v-editable="item" :style="extractCSS(item, true)" class="component" data-flex-child>
      </component>
    </div>
  </div>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  name: "cms-flow-flex",
  mixins: [cms],
}
</script>
